import React, { useLayoutEffect, useState } from "react"
import { motion } from "framer-motion"
import { CombinedRoutes } from "../Common/Routes"
import { Route, Switch } from 'react-router'
import { useDispatch, useSelector } from "react-redux"
import { setPageTitle } from "../Store/Theme/actions"
import { withRouter } from "react-router-dom"
import TopBar from "../Pages/HomePages/TopBar"
import Footer from "../Pages/HomePages/Footer"
import { useTranslation } from "react-i18next"
import { setMobileFilters, setSearchCount, setSearchValue } from "../Store/Auth/actions"
import { FaFilter, FaSearch } from "react-icons/fa"
import { AiOutlineClose } from "react-icons/ai"
// import TopBar from "../Components/TopBar"
// import Footer from "../Components/Footer"

const getUrlElem = (url) => {
    let urlSplit = url.split('/')
    let route = CombinedRoutes.filter(c => c.link !== null && c.link.split('/').length === urlSplit.length).find(c => c.link.split('/').every((i, j) => i[0] === ':' || i === urlSplit[j]))
    let urlParams = {}
    route?.link?.split('/').forEach((c, i) => {
        if (c[0] === ':') {
            urlParams[c.slice(1,)] = urlSplit[i]
        }
    })
    let { component: Elem = null, title = null, ItemIcon: icon = null, saveData = false, multiWindow = true } = route || {}
    return { Elem, title, icon, saveData, multiWindow, urlParams }
}


const MainHomeRoot = ({ history }) => {

    const dispatch = useDispatch()

    // set page title and scroll to top on route change
    useLayoutEffect(() => {
        let path = getUrlElem(history.location.pathname)
        if (path) dispatch(setPageTitle(path.title))
        
        // Scroll to top when route changes
        const contentArea = document.querySelector('.overflow-y-auto')
        if (contentArea) {
            contentArea.scrollTop = 0
        } else {
            // Fallback to window scroll if content area not found
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }, [history.location]) // eslint-disable-line

    const [searchText, setSearchText] = useState('')
    const searchCount = useSelector((state) => state.auth.searchCount)
    const {t} = useTranslation()
    const mobileFilter = useSelector((state)=>state.auth.mobileFilter)
    
    // Check if current path is view user page to hide search/filter on mobile
    const isViewUserPage = history.location.pathname.includes('/viewUser/') || history.location.pathname.includes('/fullProfile/')


    const clearSearch = () => {
            setSearchText('');
            dispatch(setSearchValue(''));
            dispatch(setSearchCount(searchCount + 1))
        }

        const searchString = () => {
                dispatch(setSearchCount(searchCount + 1))
                dispatch(setSearchValue(searchText))
            }

    return (
        <motion.div className="h-screen realtive bg-pColor flex overflow-hidden">
            <div className="w-full flex flex-col h-full">
                <motion.div className="flex-shrink-0 w-full z-10">
                    <TopBar />
                    <div className={`md:hidden bg-white flex w-96 gap-2 border items-center ${isViewUserPage ? 'hidden' : ''}`}>
                            <input
                              type="text"
                              className="flex-grow ring-none bg-white outline-none py-2 px-3"
                              value={searchText}
                              placeholder={t(`Search your partner...`)}
                              onChange={(ev) => setSearchText(ev.target.value)}
                            />
                            {searchText && <p className="cursor-pointer px-2" onClick={clearSearch}>X</p>}
                            <p className="bg-primeColor px-5 py-3 text-white h-full drop-shadow-md cursor-pointer" onClick={searchString}><FaSearch size={20} /></p>
                            <p className="bg-primeColor px-5 py-3 text-white h-full drop-shadow-md cursor-pointer" onClick={()=>dispatch(setMobileFilters(!mobileFilter))}>{mobileFilter ? <AiOutlineClose size={20}/> : <FaFilter size={20}/>}</p>
                          </div>
                </motion.div>
                <div className="text-left flex-1 md:px-10 pt-2 md:pt-4 text-tpColor overflow-y-auto">
                    <Switch>
                        {CombinedRoutes.map(c => (
                            <Route key={c.link} path={c.link} exact component={c.component} />
                        ))}
                    </Switch>
                </div>
                <motion.div className="flex-shrink-0 md:block hidden inset-x-0">
                    <Footer />
                </motion.div>
            </div>
        </motion.div>
    )
}

export default withRouter(MainHomeRoot)